export const getChartLength = (value, type) => {
  let strlen = 0
  for (let i = 0; i < (value || '').length; i++) {
    let c = (value || '').charCodeAt(i)
    //单字节加0.5
    if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
      strlen += 0.5
    } else {
      strlen++
    }
  }

  if (type == 'floor') {
    return Math.floor(strlen)
  } else {
    return Math.ceil(strlen)
  }
}
